<template>
    <div class="inc-main-div">
        <HeaderIncoming />
        <MainIncoming @closeDialog="closeDialog"/>
    </div>
</template>
<script setup lang="ts">
import { getDialogRef } from '~/composables/dynamic-dialog';
import { ModalNames } from '~/types/modals';

import HeaderIncoming from './HeaderIncoming.vue';
import MainIncoming from './MainIncoming.vue';

const dialogRef = getDialogRef(ModalNames.INCOMING_CALL);
const closeDialog = () => {
    dialogRef.value.close();
};
</script>
<style lang="scss" scoped>
.inc-main-div {
    @apply sm:max-w-md sm:w-[440px] w-11/12 rounded-lg bg-zinc-950 mx-auto h-auto overflow-y-auto;
}
</style>
